import {useMutation} from '@tanstack/react-query';
import {postMessage} from '../../services/postMessage';

export function useSendMessageMutation() {
	return useMutation({
		mutationFn: postMessage,
	});
}
